export enum OrganizationRole {
    Admin = 'Admin',
    Employee = 'Employee'
}

export enum FeatureRole {
    ActionCoordinator = 'ActionCoordinator'
}

export enum AuthRole {
    SuperAdmin = 'SuperAdmin',
    SecurityOfficer = 'SecurityOfficer'
}

export type Role = OrganizationRole | FeatureRole | AuthRole;
